// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_body__6kCz- {
  width: 100%;
  height: 100vh;
  display: flex;
  position: fixed;
  background-color: #FFFFFF;
}
.layout_body__6kCz- .layout_content__HseZa {
  width: calc(100% - 250px);
  height: inherit;
}

.layout_menubutton__i1ZHz {
  display: none;
}
@media screen and (max-width: 900px) {
  .layout_menubutton__i1ZHz {
    display: block;
    position: absolute;
    z-index: 10;
    top: 3vh;
    left: 1vw;
    cursor: pointer;
  }
}

.layout_action__fY4Cm {
  border-bottom: 1px solid #c8dad1;
  color: #5A189A;
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;
}
.layout_action__fY4Cm button {
  color: black;
  width: -moz-fit-content;
  width: fit-content;
}

header {
  display: flex;
  align-items: center;
  padding: 0 50px;
  height: 84px !important;
}
header .layout_title__\\+hkVC {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
  color: var(--Schemes-On-Surface, rgb(24, 28, 33));
}

.layout_layoutChildren__ZG0UA {
  width: auto;
  height: calc(100vh - 95px);
  padding: 0 50px;
  overflow-y: auto;
}
@media screen and (max-width: 600px) {
  .layout_layoutChildren__ZG0UA {
    padding: 10px 10px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/layout/layout.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AACJ;AACI;EACI,yBAAA;EACA,eAAA;AACR;;AAGA;EACI,aAAA;AAAJ;AAEI;EAHJ;IAIQ,cAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,SAAA;IACA,eAAA;EACN;AACF;;AAEA;EACI,gCAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AACJ;AAEI;EACI,YAAA;EACA,uBAAA;EAAA,kBAAA;AAAR;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAAJ;AAEI;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAAA;AADR;;AAKA;EACI,WAAA;EACA,0BAAA;EAEA,eAAA;EACA,gBAAA;AAFJ;AAII;EAPJ;IASQ,uBAAA;EAFN;AACF","sourcesContent":[".body {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    position: fixed;\n    background-color: #FFFFFF;\n\n    .content {\n        width: calc(100% - 250px);\n        height: inherit;\n    }\n}\n\n.menubutton {\n    display: none;\n\n    @media screen and (max-width:900px) {\n        display: block;\n        position: absolute;\n        z-index: 10;\n        top: 3vh;\n        left: 1vw;\n        cursor: pointer;\n    }\n}\n\n.action {\n    border-bottom: 1px solid #c8dad1;\n    color: #5A189A;\n    height: 70px;\n    display: flex;\n    align-items: center;\n    padding: 0 24px;\n    justify-content: space-between;\n    // width: 100%;\n\n    button {\n        color: black;\n        width: fit-content;\n    }\n}\nheader {\n    display: flex;\n    align-items: center;\n    padding:  0 50px; \n    height: 84px !important;\n\n    .title {\n        //styleName: material-theme/title/large;\n        font-family: Inter;\n        font-size: 28px;\n        font-weight: 600;\n        line-height: 36px;\n        text-align: left;\n        color: var(--Schemes-On-Surface, rgba(24, 28, 33, 1));\n\n    }\n}\n.layoutChildren {\n    width: auto;\n    height: calc(100vh - 95px);\n    overflow-y: auto;\n    padding: 0 50px;\n    overflow-y: auto;\n    // background-color: #5A189A;\n    @media screen and (max-width:600px) {\n\n        padding: 10px 10px 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `layout_body__6kCz-`,
	"content": `layout_content__HseZa`,
	"menubutton": `layout_menubutton__i1ZHz`,
	"action": `layout_action__fY4Cm`,
	"title": `layout_title__+hkVC`,
	"layoutChildren": `layout_layoutChildren__ZG0UA`
};
export default ___CSS_LOADER_EXPORT___;
